import { Calendar2Icon } from 'shared/icons/Calendar2Icon'
import styles from './CalendarButton.module.css'

interface CalendarButtonProps{
    onClick: (event: any) => void
    ref: any
}

export const CalendarButton = (props: CalendarButtonProps): JSX.Element => {
    const {
        onClick,
        ref
    } = props

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button 
            className={styles.CalendarButton}
            onClick={handleButtonClick}
            ref={ref}
        >
            <Calendar2Icon className={styles.CalendarButton__Icon} />
        </button>
    )
}